module.exports = __webpack_public_path__ + "img/kino_kunsthalle_4_b.9fbfa9d9.jpg";